import { useBroadcast, useScreensharingStream } from '@/composables'
import { screensharing } from '@/messages'
import { useUserStore, useAppStore } from '@/stores'
import { mediator, messenger } from '@communication'
import { screensharingStream } from '@stream/ScreensharingStream'

export default class ScreensharingProcedure {
  constructor() {
    this.name = 'screensharingProcedure'
    this.user = useUserStore()
  }

  install = () => {
    messenger.subscribe(this.name, ['strategy:screensharingStarted:viewer'], this.handleScreensharingStarted)
    messenger.subscribe(this.name, 'strategy:data', this.handler)
  }

  uninstall = () => {
    messenger.unsubscribe(this.name)
  }

  start = async () => {
    const { start: startScreensharing } = useScreensharingStream()
    const stream = await startScreensharing()
    stream.getVideoTracks()[0]?.addEventListener('ended', () => {
      this.stop()
    })
    screensharingStream.video.value = stream
    await mediator.connection?.startScreensharing(stream)
    const broadcast = useBroadcast()
    broadcast(screensharing.startMessage(stream.id))
    const app = useAppStore()
    app.transition('screensharing')
  }

  stop = async (broadcast = true) => {
    const { stop: stopScreensharing } = useScreensharingStream()
    stopScreensharing()
    mediator.connection?.stopScreensharing()
    if (broadcast) {
      const broadcast = useBroadcast()
      broadcast(screensharing.stopMessage())
    }
    const app = useAppStore()
    app.transition('call')
  }

  handler = (event, channel) => {
    const { type, data } = event
    switch (type) {
      case 'screensharing:stop': {
        this.stop(false)
        break
      }
    }
  }

  handleScreensharingStarted = (data) => {
    const app = useAppStore()
    console.log('Screensharing started:', data)
    const { stream } = data
    screensharingStream.video.value = stream
    app.transition('screensharing')
  }
}
